import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { patchBoardInvitation } from '../requests';

export const usePatchBoardInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchBoardInvitation,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.boardInvitations],
      });
    },
  });
};
